<template>
  <div>
    <v-container>
    <o-main-progress v-if="!loadedAll"/>
    <Condiciones
      v-else
      @terminado="terminado()"
      :incrustado="true"
      :soyAlquiler="soyAlquiler"
      :simplificada="false"
      :cargandoExterior="cargandoExterior"
    />
  </v-container>
  <v-fade-transition>
      <custom-dialog v-if="mostrarPregunta" v-model="mostrarPregunta">
        <PopUpPreguntaSimplificada :alquiler="soyAlquiler" @tipoReserva="tipoReserva=$event; preguntado= true; terminado()"/>
      </custom-dialog>
    </v-fade-transition>
  </div>
</template>

<script>
import Condiciones from '@/components/reservas/condiciones/Condiciones'
import PopUpPreguntaSimplificada from '@/components/incrustado/PopUpPreguntaSimplificada'
import { mapActions, mapGetters } from 'vuex'
import {incrustado} from '@/mixins/incrustado'
import _ from 'lodash'

export default {
  mixins: [incrustado],
  components: {
    Condiciones, PopUpPreguntaSimplificada
  },
  data () {
    return {
      variables: null,
      mostrarPregunta: false,
      cargandoExterior: false,
      preguntado: false,
      tipoReserva:null
    
    }
  },
  computed: {
    ...mapGetters({
      inmueble: 'promociones/inmuebles/getActual',
      usuario: 'login/usuario',
      promocion: 'promociones/getActual',
      codigoPromocion: 'incrustado/codigoPromocion',
      codigoActivo: 'incrustado/codigoActivo',
      numOportunidad:'incrustado/numOportunidad',
      reserva: 'reservas/_id/getActual',
      usuarioComercial: 'incrustado/usuarioComercial',
      modulosOrden: 'modulosOrdenes/getActual',
      scoring: 'scoring/get'
    }),
    jsondata () {
      return JSON.parse(this.$route.query.jsondata)
    },
    idubapi () {
      return this.jsondata ? this.jsondata.parametros.idubapi : null
    },
    emailComercial () {
      return this.jsondata ? this.jsondata.parametros.usuarioComercial.email : null
    },
    cod_cli () {
      return this.jsondata ? this.jsondata.parametros.cod_cli : null
    },
    token () {
      return this.jsondata ? this.jsondata.parametros.token : null
    },
    datosContacto () {
      return this.jsondata ? this.jsondata.parametros.datosContacto : null
    },
    objetoParaApi () {
      return {
        codigoPromocion: this.codigoPromocion,
        simplificada: true,
        codigoActivo: this.codigoActivo,
        numOportunidad: this.numOportunidad,
        alquiler: this.soyAlquiler,
        compradoresScoring: this.scoring.compradores !== undefined ? this.scoring.compradores : null,
        compradorTitular:  {
          conDatosContacto: this.datosContacto ? true : false,
          nombre: this.datosContacto ? this.datosContacto.nombre : null,
          apellidos: this.datosContacto ? this.datosContacto.apellidos : null,
          email: this.datosContacto ? this.datosContacto.email.replace(' ', '+') : null,
          tipoDocumentoID: this.datosContacto ? 'N' : null,
          nif: this.datosContacto ? this.datosContacto.documento : null,
          tipoPersona: this.datosContacto ? this.datosContacto.tipoPersona : null,
          fechaNacimiento: this.datosContacto ? this.datosContacto.fechaNacimiento : null,
          sexo: this.datosContacto ? this.datosContacto.sexo : null,
          estadoCivil: this.datosContacto ? this.datosContacto.estadoCivil : null,
          nacionalidad: this.datosContacto ? this.datosContacto.nacionalidad : null,
          sigla: this.datosContacto ? this.datosContacto.sigla : null,
          domicilio: this.datosContacto ? this.datosContacto.domicilio : null,
          numero: this.datosContacto ? this.datosContacto.numero : null,
          escalera: this.datosContacto ? this.datosContacto.escalera : null,
          piso: this.datosContacto ? this.datosContacto.piso : null,
          puerta: this.datosContacto ? this.datosContacto.puerta : null,
          pais: this.datosContacto ? this.datosContacto.pais : null,
          provincia: this.datosContacto ? this.datosContacto.provincia : null,
          poblacion: this.datosContacto ? this.datosContacto.poblacion : null,
          codigoPostal: this.datosContacto ? this.datosContacto.codigoPostal : null,
          telefono: this.datosContacto ? this.datosContacto.telefono : null,
          telefono2: this.datosContacto ? this.datosContacto.telefono2 : null,
          movil: this.datosContacto ? this.datosContacto.movil : null,
          fax: this.datosContacto ? this.datosContacto.fax : null,
          proteccionDatos: this.datosContacto ? this.datosContacto.proteccionDatos : null
        },
        usuarioComercial: this.usuarioComercial != null ? this.usuarioComercial : null,
      }
    },
    soyAlquiler () {
      return this.$route.name.endsWith('condicionesAlquiler')
    }
  },
  methods: {
    ...mapActions({
      loadInmueble: 'promociones/inmuebles/load',
      loginCRM: 'login/loginCRMSimplificada',
      loadActual: 'modulosOrdenes/loadActual',
      crearReserva: 'reservas/_id/crear',
      loadReserva: 'reservas/_id/load',
      loadInicios: 'configuracion/variablesConfiguracion/loadIniciosProcesos',
      loadPoliticaPrivacidad: 'configuracion/politicaPrivacidad/load',
      setVariableAlquiler: 'incrustado/alquiler',
      addAlert: 'alerts/add'
    }),
    async initialize () {
      try {
        await Promise.all([
          this.loadInmueble({
            codigoPromocion: this.codigoPromocion,
            codigoActivo: this.codigoActivo,
            alquiler: this.soyAlquiler
          }),
          this.loadPoliticaPrivacidad()
        ])
        this.variables = await this.loadInicios(this.codigoPromocion)
        if (this.alquiler && this.variables.alquiler == null) {
          this.variables = await this.loadInicios(-1)
        } else if (!this.alquiler && this.variables.venta == null) {
          this.variables = await this.loadInicios(-1)
        }
        // comprobación existen los datos
        if (this.inmueble == null ||
          (this.inmueble.tarifa == null && this.inmueble.tarifaAlquiler == null) ||
          this.promocion == null
        ) {
          this.$router.push({name: 'incrustado.mensajeError'})
          return false
        }
        return true
      } catch (error) {
        if (!error.code || (error.code !== 1 && error.code !== 11 && error.code !== 10)) {
          this.addAlert({texto: error.message, color: 'error'})
          this.$router.push({name: 'incrustado.mensajeError'})
        } else if (error.code === 11) {
          this.$router.push({name: 'incrustado.mensajeReservado', params: {reservaUsuario: true}})
        } else if (error.code === 10) {
          this.$router.push({name: 'incrustado.mensajeReservado', params: {reservaUsuario: false}})
        }
        return false
      }
    },
    async terminado () {
      try {
        if (this.soyAlquiler) {
          if (this.numOportunidad && (this.variables.alquiler != null && this.variables.alquiler.valor == 'N') && !this.preguntado) {
            this.mostrarPregunta = true
            return
          } else {
            await this.loadActual({ alquiler: this.soyAlquiler, codigoPromocion: this.codigoPromocion, simplificada: (this.variables.alquiler == null || !this.numOportunidad) ? false : !this.preguntado ? this.variables.alquiler.valor == 'S' : this.tipoReserva == 'simplificada' })
          }
        }  else {
          if (this.numOportunidad && (this.variables.venta != null && this.variables.venta.valor == 'N') && !this.preguntado) {
            this.mostrarPregunta = true
            return
          } else {
            await this.loadActual({ alquiler: this.soyAlquiler, codigoPromocion: this.codigoPromocion, simplificada: (this.variables.venta == null || !this.numOportunidad) ? false : !this.preguntado ? this.variables.venta.valor == 'S' : this.tipoReserva == 'simplificada'})
          }
        }
      } catch (error) {
        if (!error.code || (error.code !== 1 && error.code !== 11 && error.code !== 10)) {
          this.addAlert({texto: error.message, color: 'error'})
          this.$router.push({name: 'incrustado.mensajeError'})
        }
        return false
      }
      
      
      this.setVariableAlquiler(this.soyAlquiler)
      // this.$router.push({name: 'incrustado.registro'})
      if (this.numOportunidad && this.modulosOrden && this.modulosOrden.simplificada == 1) {
        if (this.soyAlquiler && this.modulosOrden.scoring) {
          this.$router.push({name: 'incrustado.scoring', params: {parametrosSimplificada: {objetoParaApi : this.objetoParaApi, idubapi: this.idubapi, cod_cli: this.cod_cli, token: this.token, emailComercial: this.emailComercial}, simplificada:!this.numOportunidad ? false : !this.preguntado ? this.variables.alquiler.valor == 'S' : this.tipoReserva == 'simplificada'}} )
        } else {
          this.cargandoExterior = true
          await this.loginCRM({
            id_bd_prinex: this.idubapi,
            cod_cli: this.cod_cli,
            token: this.token, 
            simplificada: true,
            email_comercial: this.emailComercial
          })
          await this.crearReserva(this.objetoParaApi)
          await this.loadReserva(this.reserva.id)
          this.$router.push({name: 'reservas.id.simplificada', params: { id: this.reserva.id }})
        }
        
        // this.$router.push({name: 'loginSimplificada', params: {simplificada: 'simplificada', alquiler: 'alquiler'}})
      } else {
        if (!this.soyAlquiler || !this.modulosOrden.scoring) {
          this.$router.push({name: 'incrustado.registro'})
        } else {
          if (_.isEmpty(this.scoring)) {
            this.$router.push({name: 'incrustado.scoring', params: {simplificada:!this.numOportunidad ? false : !this.preguntado ? this.variables.alquiler.valor == 'S' : this.tipoReserva == 'simplificada'}} )
          } else {
            if (this.scoring.alquilerMaximo >= parseFloat(this.inmueble.tarifa_importeTotal)) {
              this.$router.push({name: 'incrustado.registro'})
            } else {
              this.addAlert({texto: this.$t('pages.incrustado.scoringNoApto'), color: 'error'})
              this.$router.push({name: 'incrustado.listaInmueblesAlquiler'})
            }
          }
        }
      }
      
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/incrustado/condiciones.vue